import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

const ApiService = {

  setAuthorizationHeader (token) {
    Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },

  query (resource, params) {
    return Vue.axios.get(resource, { params })
    
  },

  cancelableQuery (resource, params, cancelationCallback, token = null) {
    let config = {
      params: params,
      cancelToken: cancelationCallback
    }
    if(token) {
      config.headers= {'Authorization': `Bearer ${token}`}
    }
    return Vue.axios.get(resource, config)
  },

  get (resource, slug = '', params = {}) {
    return Vue.axios.get(slug !== '' ? `${resource}/${slug}` : resource, typeof params === 'object' ? params : { params })
  },

  blob (resource, params) {
    return Vue.axios.get(resource, { params, responseType: 'blob' })
  },

  post (resource, params, options = {}) {
    return Vue.axios.post(`${resource}`, params, options)
  },

  patch (resource, params, options = {}) {
    this.setAuthorizationHeader()
    return Vue.axios.patch(`${resource}`, params, options)
  },

  put (resource, params) {
    return Vue.axios.put(`${resource}`, params)
  },

  delete (resource, params) {
    if (params) {
      return Vue.axios.delete(resource, params)
    }
    return Vue.axios.delete(resource)
  }
}

export default ApiService
